import React from 'react';

import { Button } from 'components/actions/Button';
import { ButtonColorsEnum } from 'constants/button-colors';
import { IconsEnum } from 'constants/icons';
import { MediaLibraryFilterMenu } from '../MediaLibraryFilterMenu';
import {
  FilterMenuContextType,
  MediaLibraryFilterMenuViewProps
} from '../MediaLibraryFilterMenu/MediaLibraryFilterMenu.view';
import { FilterDropdown } from '../../../../components/containers/FilterDropdown';

export type ThirdNavLeftButtonsProps = Omit<MediaLibraryFilterMenuViewProps, 'context'> & {
  open: boolean;
  setOpen: (show: boolean) => void;
};

export type ThirdNavRightButtonsProps = {
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
};

export const ThirdNavLeftButtons = (props: ThirdNavLeftButtonsProps): JSX.Element => (
  <>
    <div className={'show-for-small-only'}>
      <Button
        type={'button'}
        variant={'hollow'}
        size={'medium'}
        color={ButtonColorsEnum.primary}
        icon={{
          side: 'left',
          value: IconsEnum.filter
        }}
        action={() => {
          props.setOpen(true);
        }}>
        Filters
      </Button>
    </div>
    <FilterDropdown breakPointClasses={['show-for-medium', 'hide-for-xxlarge']}>
      <MediaLibraryFilterMenu
        filters={props.filters}
        dispatchFilters={props.dispatchFilters}
        context={FilterMenuContextType.DROPDOWN}
      />
    </FilterDropdown>
  </>
);
export const ThirdNavRightButtons = ({ onClick }: ThirdNavRightButtonsProps) => (
  <>
    <div className={'hide-for-small-only'}>
      <Button
        type={'button'}
        variant={'solid'}
        size={'medium'}
        color={ButtonColorsEnum.primary}
        icon={{ side: 'left', value: IconsEnum.plus }}
        action={onClick}>
        <span className={'hide-for-small-only'}>Add Media</span>
      </Button>
    </div>
    <div className={'show-for-small-only'}>
      <Button
        type={'button'}
        variant={'solid'}
        size={'medium'}
        color={ButtonColorsEnum.primary}
        icon={{ side: 'center', value: IconsEnum.plus }}
        action={onClick}
      />
    </div>
  </>
);
